"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _react = _interopRequireDefault(require("react"));
var _HiSelect = _interopRequireDefault(require("./HiSelect"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // @inheritedComponent HiSelect
/**
 * HiDynamicSelect hérite du composant HiSelect
 *
 * Sa fonction buildSelectProps construit la liste des options
 * selon l'état du chargement des options.
 * La valeur de l'input n'est pas définie et hérite donc du comportement de HiSelect.
 * La prop nextPage définit le comportement pour la demande de nouvelle donnée:
 * - none: aucune nouvelles données
 * - auto: (ex infinity scroll) nouvelle demande lorsqu'on atteint le bas de scroll vertical
 * - manual: ajoute un bouton en bas de la liste.
 */
var HiDynamicSelect = /*#__PURE__*/function (_React$PureComponent) {
  function HiDynamicSelect(props) {
    var _this;
    (0, _classCallCheck2.default)(this, HiDynamicSelect);
    _this = _callSuper(this, HiDynamicSelect, [props]);
    _this.handleScrollReachBottom = function () {
      if (!_this.props.loading && _this.props.nextPage === 'auto' && _this.props.onNextPage) {
        _this.props.onNextPage();
      }
    };
    /**
     * Call onChange with the updated value
     *
     * - handle single value
     * - handle multiple value
     *
     * @param event
     * @param item
     */
    _this.handleSelect = function (event, item) {
      var _this$props = _this.props,
        multiple = _this$props.multiple,
        onChange = _this$props.onChange,
        value = _this$props.value;
      if (item.id === '_next_page' && !_this.props.loading && _this.props.nextPage === 'manual' && _this.props.onNextPage) {
        _this.props.onNextPage();
      }
      if (!multiple) {
        // single value
        onChange(event, item.id, item);
      } else if (value.includes(item.id)) {
        // unselect item
        onChange(event, value.filter(function (id) {
          return id !== item.id;
        }), item);
      } else {
        onChange(event, [].concat((0, _toConsumableArray2.default)(value), [item.id]), item);
      }
    };
    /**
     * Build itemList & inputValue from select props
     * @param options
     * @param value
     * @param search
     * @param loading
     * @returns {{itemList: *[], inputValue: *}}
     */
    // eslint-disable-next-line no-unused-vars
    _this.buildSelectProps = function (options) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var search = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var loading = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var _this$props2 = _this.props,
        nextPage = _this$props2.nextPage,
        translations = _this$props2.translations;
      var itemList = [].concat((0, _toConsumableArray2.default)(options.length === 0 && !loading ? [{
        id: '_no_result',
        type: 'text',
        disabled: true,
        centered: true,
        hideCheckbox: true,
        label: translations.no_result_match
      }] : []), (0, _toConsumableArray2.default)(options), (0, _toConsumableArray2.default)(!loading && nextPage === 'manual' ? [{
        id: '_next_page',
        type: 'button',
        centered: true,
        hideCheckbox: true,
        label: translations.next_page
      }] : []), (0, _toConsumableArray2.default)(loading ? [{
        id: '_loading',
        type: 'loader',
        disabled: true,
        centered: true,
        hideCheckbox: true,
        label: 'loading'
      }] : []));
      return {
        itemList: itemList
      };
    };
    _this.handleScrollReachBottom = _this.handleScrollReachBottom.bind(_this);
    _this.handleSelect = _this.handleSelect.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(HiDynamicSelect, _React$PureComponent);
  return (0, _createClass2.default)(HiDynamicSelect, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        hiSelectableListProps = _this$props3.hiSelectableListProps,
        multiple = _this$props3.multiple,
        nextPage = _this$props3.nextPage,
        options = _this$props3.options,
        translations = _this$props3.translations,
        value = _this$props3.value,
        other = (0, _objectWithoutProperties2.default)(_this$props3, ["hiSelectableListProps", "multiple", "nextPage", "options", "translations", "value"]);
      return /*#__PURE__*/_react.default.createElement(_HiSelect.default, (0, _extends2.default)({
        buildSelectProps: this.buildSelectProps,
        hiSelectableListProps: (0, _objectSpread2.default)({}, hiSelectableListProps),
        multiple: multiple,
        options: options,
        searchable: true,
        translations: translations,
        value: value
      }, nextPage === 'auto' && {
        onScrollReachBottom: this.handleScrollReachBottom
      }, other));
    }
  }]);
}(_react.default.PureComponent);
HiDynamicSelect.defaultProps = {
  loading: false,
  multiple: false,
  nextPage: 'none',
  translations: {
    no_result_match: 'No result match',
    search: 'Search',
    n_items_selected: '%s items selected',
    one_item_selected: '%s item selected',
    n_children: '%s items',
    one_child: '%s item',
    next_page: 'Load more'
  }
};
var _default = exports.default = HiDynamicSelect;